import { type Context, createContext } from 'react';

export type ExternalLinkContextProps = {
  openLink: (href: string) => void;
};

export const defaultExternalLink = (_: string) => {};

export const ExternalLinkContext: Context<ExternalLinkContextProps> =
  createContext({
    openLink: defaultExternalLink,
  });
